import GuideOverlay from 'components/GuideOverlay';
import Loading from 'components/LoadingOverlay';
import { localizable } from 'components/Localization';
import Prompt from 'components/Prompt';
import { observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import {
  DetailsList,
  DetailsListLayoutMode,
} from 'office-ui-fabric-react/lib/DetailsList';
import { Link } from 'office-ui-fabric-react/lib/Link';
import React, { Component, Fragment } from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

@inject('mls', 'user', 'inventory', 'app')
@localizable
@observer
class Mls extends Component {
  @observable creating = false;
  @observable openPrompt = false;
  @observable selectedSale = null;

  componentWillMount() {
    const { mls, t } = this.props;
    mls.load();
    mls.initColumns(t, this.handleColumnHeaderClick);
  }

  handleColumnHeaderClick = (e, column) => {
    const { mls } = this.props;
    mls.sortBy(column.fieldName);
  };

  handleRenderObjectColumn = (item, _, column) => {
    const content = item[column.fieldName];
    const { roundNumber, roundType, roundStatus, endAt } = item;
    const { t } = this.props;
    switch (column.key) {
      case 'title':
        return (
          <span>
            {item.inviteOnly ? (
              <Fragment>
                <Icon iconName="LockSolid" />{' '}
              </Fragment>
            ) : null}
            {content}
          </span>
        );
      case 'itemNumber':
        return <Link data-selection-invoke={true}>{content}</Link>;
      case 'status':
        return (
          <span content={content}>
            {t('statusvalue', {
              content,
              roundNumber,
              roundType,
              roundStatus,
              endAt: endAt.toFormatedDateString(),
            })}
          </span>
        );
      case 'startAt':
      case 'endAt':
        return <span>{content ? content.toFormatedDateString() : ''}</span>;
      default:
        return <span>{content}</span>;
    }
  };

  handleItemInvoked = (item, _) => {
    const { history } = this.props;
    if (item.inviteOnly) {
      runInAction(() => {
        this.selectedSale = item;
        this.openPrompt = true;
      });
    } else {
      history.push(`/dashboard/${item.id}`);
    }
  };

  handleBack = () => {
    const { history } = this.props;
    history.push(`/dashboard`);
  };

  handleRequestAccess = async () => {
    const { history, mls, user } = this.props;
    const ok = await mls.requestAccess({
      saleId: this.selectedSale.id,
      userId: user.profile.sub,
      agent: user.agentData(),
    });
    this.openPrompt = false;
    if (ok) {
      history.push(`/dashboard`);
    }
  };

  render() {
    const { app, mls, t } = this.props;

    return (
      <Fragment>
        <div className="title">
          <a className="back" onClick={this.handleBack}>
            <i className="ms-Icon ms-Icon--NavigateBack" aria-hidden="true" />
            <span>{t('Back')}</span>
          </a>
          <span>{t('mls')}</span>
        </div>

        <div className="content-without-menu">
          {
            /* fetching */
            mls.fetching && (
              <div style={{ marginTop: 5 }}>
                <Loading label={t('Loading mls') + '...'} />
              </div>
            )
          }
          {
            /* no active mls */
            !mls.fetching && (!mls.items || !mls.items.length) && (
              <GuideOverlay theme={app.theme}>
                <span>
                  <p>{t('no sale for mls')}</p>
                </span>
              </GuideOverlay>
            )
          }
          {
            /* you have some active mls */
            !mls.fetching && mls.items && mls.items.length && (
              <DetailsList
                columns={mls.columns}
                items={mls.items}
                onRenderItemColumn={this.handleRenderObjectColumn}
                onItemInvoked={this.handleItemInvoked}
                selectionMode={1}
                checkboxVisibility={2}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                selectionPreservedOnEmptyClick={true}
              />
            )
          }
        </div>
        <Prompt
          title={t('Request Access')}
          opened={this.openPrompt}
          onClose={() => (this.openPrompt = false)}
          onSubmit={this.handleRequestAccess}
        >
          <div>{t('Request Access Description')}</div>
        </Prompt>
      </Fragment>
    );
  }
}

export default Mls;



// WEBPACK FOOTER //
// ./src/app/containers/Overview/Mls.jsx